import { Link, useLocation } from 'react-router';
import { Panel } from '../components/ui';
import { PageHeader } from '../components/PageHeader';

export default function NotFoundPage() {
  const { pathname } = useLocation();
  return (
    <>
      <PageHeader title="Not found" />
      <Panel>
        <div className="px-5 py-9 text-center text-ink-2">
          <p className="m-0 text-[12.5px]">
            <code className="num text-ink">{pathname}</code> is not a route in this application.
          </p>
          <p className="mt-3 mb-0 text-[12.5px]">
            <Link to="/" className="text-accent-ink underline">
              Back to Home
            </Link>
          </p>
        </div>
      </Panel>
    </>
  );
}
